import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const reportSelector = createFeatureSelector<IState>('report');
export const getReportsSelector = createSelector(reportSelector, (state: IState) => state); 
export const getReportSelector = createSelector(reportSelector, (state: IState) => state.selectedItem); 
